import script from "./DirectorList.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectorList.vue?vue&type=script&setup=true&lang=js"

import "./DirectorList.vue?vue&type=style&index=0&id=4f98068c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f98068c"]])

export default __exports__